<template>
  <svg
    class="expand-icon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="none" />
    <path
      d="M6 18V14H7.08331V16.9167H10V18H6ZM6 10V6H10V7.08331H7.08331V10H6ZM14 18V16.9167H16.9167V14H18V18H14ZM16.9167 10V7.08331H14V6H18V10H16.9167Z"
      fill="#F2F2F2"
    />
  </svg>
</template>

<script>
export default {
  name: "ExpandIcon",
};
</script>
